import { load as recaptchaLoad } from 'recaptcha-v3';

$(function(){
    
    // get captcha site key
    const siteKey = Utils.getRecaptchaSiteKey();

    function handleRecaptchaToken(){

        recaptchaLoad(siteKey).then((recaptcha) => {
            // get captcha token
            recaptcha.execute('post_form').then((token) => {
                
                // set token to form
                $('form.PostCaptchaForm').find('.recaptcha-response').val(token);
            });
        });
        
    }

    // if form with captcha input is present and we have site key
    if ( $('form.PostCaptchaForm').find('.recaptcha-response').length && siteKey.length )
    {
        // set token
        handleRecaptchaToken();

        // set token every minute
        setInterval(handleRecaptchaToken, 60000);
    }

});